import { ensureRouteData, prefetchRouteData } from '@/app/query-client'
import { signalDashboardQueryOptions } from '@/features/signals/api/queries'
import { chartHistoryHeadQueryOptions } from '@/features/trading-chart/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import { NEPSE_SYMBOL } from '@/screens/signals/lib/nepse-window'

/**
 * The `/market/signals` (dashboard) loader. MAIN: the latest session's counts
 * and market block — no search params, as the dashboard has no picker (owner
 * ruling S1, 2026-10-29). SECONDARY, started first so it overlaps it: the NEPSE
 * section's bars (one read for every session, which the section draws its own
 * skeleton and error for). The bars are the chart's own
 * first read, so its first `getBars` answers from them while its library
 * loads. The trading-chart queries already ship in the entry with the chart
 * route's loader, so this costs the entry nothing.
 */
export async function loadSignalZone({
  context: { queryClient },
  preload,
}: {
  context: RouterContext
  preload: boolean
}): Promise<void> {
  if (!preload) prefetchRouteData(queryClient, chartHistoryHeadQueryOptions(NEPSE_SYMBOL))
  await ensureRouteData(queryClient, signalDashboardQueryOptions(null))
}
